import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/AndyDunkelHell/'
      className='link footer__link'
    >
      Created By Andres Gonzalez
    </a>
  </footer>
)

export default Footer
